import { Component, OnInit } from '@angular/core';
import {GlobalDataService, IsAdmin, ResetAuthToken} from '../global-data.service';
import {AuthenticationService} from '../authentication-service.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CreateSubscriptionService} from '../create-subscription.service';
import {Subscription} from '../app-models/models';

@Component({
  selector: 'app-create-subscription',
  templateUrl: './create-subscription.component.html',
  styleUrls: ['./create-subscription.component.css'],
  providers: [CreateSubscriptionService]
})
export class CreateSubscriptionComponent implements OnInit {

  private id: string;
  private compObj: Subscription = new Subscription();
  private actionMessage: string;
  private actionStatus = true;

  constructor(private globalDataService: GlobalDataService, private authService: AuthenticationService,
              private router: Router, private componentService: CreateSubscriptionService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.authenticate();
  }

  authenticate(): void {
    if (this.globalDataService.token == null || !IsAdmin.call(this)) {
      this.router.navigate(['/login']);
    } else {
      this.authService.Authenticate().then(this.main.bind(this))
        .catch(this.handleAuthenticationError.bind(this));
    }
  }

  handleAuthenticationError(e) {
    ResetAuthToken.call(this);
  }

  main(result): void {
    this.route.queryParams
      .subscribe(params => {
        this.id = params['custId'];
      });
    this.componentService.getData(this.id).then(this.mainSuccess.bind(this))
      .catch(this.mainFail.bind(this));
  }

  mainSuccess(result) {
    this.compObj = result;
  }

  mainFail(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    }
  }

  onSubmit() {
    this.actionMessage = null;
    this.componentService.createSubscription(this.compObj).then(this.submitSuccess.bind(this))
      .catch(this.submitFail.bind(this));
  }

  submitFail(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    } else {
      this.actionStatus = false;
      this.actionMessage = 'Submit Failed!';
    }
  }

  submitSuccess(result = null) {
    this.actionStatus = true;
    this.actionMessage = 'Success!';
  }

}



// WEBPACK FOOTER //
// ./src/app/create-subscription/create-subscription.component.ts